export default{
    
    // Products->SatelliteData
    satelliteLists:[
        {
            level1:'Resolution 0.5m',
            children:[
                {
                    level2:'',
                    imgUrl:require('../../assets/img/product/2gaojing1.png')
                },{
                    level2:'',
                    imgUrl:require('../../assets/img/product/2wv1.png')
                },{
                    level2:'',
                    imgUrl:require('../../assets/img/product/2wv2.png')
                },{
                    level2:'',
                    imgUrl:require('../../assets/img/product/2wv3.png')
                },{
                    level2:'',
                    imgUrl:require('../../assets/img/product/2airbus2.png')
                }
            ]
        },{
            level1:'Resolution 0.8m',
            children:[
                {
                    level2:'',
                    imgUrl:require('../../assets/img/product/2gaofen2.png')	
                },{
                    level2:'',
                    imgUrl:require('../../assets/img/product/2airbus1.png')
                }
            ]
        },{
            level1:'Resolution 2.0m',
            children:[
                {
                    level2:'',
                    imgUrl:require('../../assets/img/product/2gaofen1.png')	
                },{
                    level2:'',
                    imgUrl:require('../../assets/img/product/2ziyuan1.png')	
                }
            ]
        }
    ],
        // Products->GNSS
    GNSSLists:[
        {
            imgUrl:require('../../assets/img/overseas/GNSS01.png'),
            type:'',
            children:[
                {
                    categoryCon:'Project No',
                    detailCon:'A1008',
                },{
                    categoryCon:'LCD',
                    detailCon:'10“ 1920x1200 500nits',
                    markCon:'sunlight visible'
                },
                { categoryCon:'Touch Panel',detailCon:'Capacitive'},
                { categoryCon:'Pen',detailCon:'Y'},
                { categoryCon:'Size',detailCon:'256*185*17mm'},
                { categoryCon:'Weight',detailCon:'950g'},
                { categoryCon:'Drop Test',detailCon:'1.2m'},
                { categoryCon:'Water proof',detailCon:'IP67'},
                { categoryCon:'Work Temp',detailCon:'-20℃ ~60℃'},
                { categoryCon:'Storage Temp',detailCon:'-30℃ ~70℃'},
                { categoryCon:'CPU',detailCon:'Qualcomm SM4350 2*Kyro 470 Gold (A76) 2.0GHz+6*A78 Kyro 460 Silver (A55) 1.8GHz'},
                { categoryCon:'OS',detailCon:'Android 13'},
                { categoryCon:'RAM',detailCon:'6GB/8GB'},
                { categoryCon:'Flash',detailCon:'128GB/256GB'},
                { categoryCon:'Rear Camera',detailCon:'13M'},
                { categoryCon:'Front Camera',detailCon:'5M'},
                { categoryCon:'Flast Light',detailCon:'Y'},
                { categoryCon:'WIFI',detailCon:'802.11 a/b/g/n/ac/ax,  2.4GHz/5GHz'},
                { categoryCon:'Network',detailCon:`GSM: 850/900/1800/1900
SDMA: BC0<br>
WCDMA: B1/B2/B5/B8<br>
TD-SCDMA: B34/B38/B39/B40/B41<br>
LTE: B1/B2/B3/B4/B5/B7/B8/B12/B20/B28<br>
NR5G: N1/N3/N28/N41/N78/N79`},
                { categoryCon:'SIM Card',detailCon:'Dual SIM & Dual Standby'},
                { categoryCon:'T Card',detailCon:'Support'},
                { categoryCon:'Bluetooth',detailCon:'BT5.1'},
                { categoryCon:'USB',detailCon:`Type C *1, support Display Port<br>
USB2.0 *2 Type A<br> 3.5mm audio*1`},
                { categoryCon:'Battery',detailCon:'11700mAh'},
                { categoryCon:'Fast Charge',detailCon:'Support QC3.0'},
                { categoryCon:'NFC',detailCon:'Support'},
                { categoryCon:'RGB',detailCon:'Support'},
                { categoryCon:'Fingerprint',detailCon:'Support'},
                { categoryCon:'G Sensor',detailCon:'Support'},
                { categoryCon:'Gyroscope',detailCon:'Support'},
                { categoryCon:'Light Sensor',detailCon:'Support'},
                { categoryCon:'E Compass',detailCon:'Support'},
                { categoryCon:'Vibrator',detailCon:'Support'},
                { categoryCon:'Enternal GNSS ANT',detailCon:'GPS/GLONASS/BeiDou, L1+L5 GPS'},
                { categoryCon:'High Precision GNSS',detailCon:'UM980/F9P',markCon:'optional'},
                { categoryCon:'Scanner',detailCon:'2D Scanner/External',markCon:'optional'},
                { categoryCon:'Extended Interface',detailCon:`12PIN Back Pogopin，UART/USB/DCIN/GPIO<br> 10PIN Bottom Pogopin，USB2.0/DCIN/GPIO`},
                { categoryCon:'SPK',detailCon:'Support'},
                { categoryCon:'MIC',detailCon:'Support'},
                { categoryCon:'Keypad',detailCon:'Power, Volume up/down, F1 、F2 、F3'},
            ]
        },{
            imgUrl:require('../../assets/img/overseas/GNSS02.png'),
            type:'',
            children:[
                {
                    categoryCon:'Project No',
                    detailCon:'A6001',
                },{
                    categoryCon:'LCD',
                    detailCon:'6“ 1440x720 500nits',
                    markCon:'sunlight visible'
                },
                { categoryCon:'Touch Panel',detailCon:'Capacitive'},
                { categoryCon:'Size',detailCon:'81.6*162*13mm'},
                { categoryCon:'Weight',detailCon:'265g'},
                { categoryCon:'Drop Test',detailCon:'1.2m'},
                { categoryCon:'Water proof',detailCon:'IP67'},
                { categoryCon:'Work Temp',detailCon:'-20℃ ~60℃'},
                { categoryCon:'Storage Temp',detailCon:'-30℃ ~70℃'},
                { categoryCon:'CPU',detailCon:'Qualcomm SDM632 8*1.8GHZ (4*A73+4*A53)'},
                { categoryCon:'OS',detailCon:'Android 10GMS'},
                { categoryCon:'RAM',detailCon:'4GB'},
                { categoryCon:'Flash',detailCon:'64GB'},
                { categoryCon:'Rear Camera',detailCon:'13M'},
                { categoryCon:'Front Camera',detailCon:'5M'},
                { categoryCon:'Flast Light',detailCon:'Y'},
                { categoryCon:'WIFI',detailCon:'802.11 a/b/g/n/ac,  2.4GHz/5GHz'},
                { categoryCon:'Network',detailCon:`GSM: 850/900/1800/1900
CDMA: BC0<br>
EVDO：BC0<br>
WCDMA: B1/B2/B5/B8<br>
TD-SCDMA:B34/B39<br>
TDDLTE:Band38/Band39/Band40/Band41<br>
FDDLTE:Band1/Band2/Band3/Band4/Band5/Band7/
Band8/Band17/Band20/Band28`},
                { categoryCon:'SIM Card',detailCon:'Dual SIM & Dual Standby'},
                { categoryCon:'T Card',detailCon:'Y'},
                { categoryCon:'Bluetooth',detailCon:'BT4.2'},
                { categoryCon:'USB',detailCon:`Type C`},
                { categoryCon:'Battery',detailCon:'5000mAh'},
                { categoryCon:'Fast Charge',detailCon:'5V2A'},
                { categoryCon:'Wireless Charge',detailCon:'Y',markCon:'optional'},
                { categoryCon:'NFC',detailCon:'Y'},
                { categoryCon:'1D/2D Scanner',detailCon:'Y',markCon:'optional'},
                { categoryCon:'Fingerprint',detailCon:'Y',markCon:'optional'},
                { categoryCon:'G Sensor',detailCon:'Y'},
                { categoryCon:'Gyroscope',detailCon:'Y'},
                { categoryCon:'Light Sensor',detailCon:'Y'},
                { categoryCon:'E Compass',detailCon:'Y'},
                { categoryCon:'GNSS',detailCon:'GPS/Glonass/Beidou/Galileo'},
                { categoryCon:'GPS',detailCon:'Ublox M8N'},
                { categoryCon:'GPS Antenna',detailCon:'Patch Antenna'},
                { categoryCon:'Extended Interface',detailCon:`USB, UART, GPIO`},
                { categoryCon:'Keypad',detailCon:'Power，Volume up/down, Function Buttons'},
            ]
        },{
            imgUrl:require('../../assets/img/overseas/GNSS03.png'),
            type:'',
            children:[
                {
                    categoryCon:'Project No',
                    detailCon:'A8003',
                },{
                    categoryCon:'LCD',
                    detailCon:'8"  HD 1280*800  500Nits',
                    markCon:'sunlight visible'
                },
                { categoryCon:'Touch Panel',detailCon:'Capacitive'},
                { categoryCon:'Size',detailCon:'235*146*13mm'},
                { categoryCon:'Weight',detailCon:'560g'},
                { categoryCon:'Drop Test',detailCon:'1.2m'},
                { categoryCon:'Water proof',detailCon:'IP67'},
                { categoryCon:'Work Temp',detailCon:'-20℃ ~60℃'},
                { categoryCon:'Storage Temp',detailCon:'-30℃ ~70℃'},
                { categoryCon:'CPU',detailCon:'Qualcomm SDM632 8*1.8GHZ(4*A73+4*A53)'},
                { categoryCon:'OS',detailCon:'Android 10GMS'},
                { categoryCon:'RAM',detailCon:'4GB'},
                { categoryCon:'Flash',detailCon:'64GB'},
                { categoryCon:'Rear Camera',detailCon:'13M'},
                { categoryCon:'Front Camera',detailCon:'5M'},
                { categoryCon:'Flast Light',detailCon:'Y'},
                { categoryCon:'WIFI',detailCon:'802.11 a/b/g/n/ac,  2.4GHz/5GHz'},
                { categoryCon:'Network',detailCon:`GSM: 850/900/1800/1900<br>
WCDMA: B1/B2/B5/B8<br>
TD-SCDMA: B34/B39<br>
TDDLTE:Band38/Band39/Band40/Band41<br>
FDDLTE:Band1/Band2/Band3/band4/band5/Band7/<br>band8/band17/band20/band28`},
                { categoryCon:'SIM Card',detailCon:'Dual sim &  Dual standby'},
                { categoryCon:'T Card',detailCon:'Y'},
                { categoryCon:'Bluetooth',detailCon:'BT4.2'},
                { categoryCon:'USB',detailCon:`Type C`},
                { categoryCon:'Battery',detailCon:'8000mAh'},
                { categoryCon:'Fast Charge',detailCon:'QC3.0',markCon:'optional'},
                { categoryCon:'Wireless Charge',detailCon:'Y'},
                { categoryCon:'NFC',detailCon:'Y'},
                { categoryCon:'Fingerprint',detailCon:'N/A'},
                { categoryCon:'G Sensor',detailCon:'Y'},
                { categoryCon:'Gyroscope',detailCon:'Y'},
                { categoryCon:'Light Sensor',detailCon:'Y'},
                { categoryCon:'E Compass',detailCon:'Y'},
                { categoryCon:'GNSS',detailCon:'GPS/BDS/GNSS/GALILEO'},
                { categoryCon:'GPS',detailCon:'Ublox M8N'},
                
                { categoryCon:'External GPS Antenna',detailCon:'Y'},
                { categoryCon:'Extended Interface',detailCon:`USB, UART, I2C, GPIO`},
                { categoryCon:'Keypad',detailCon:'Power，Volume up/down, F1, F2'},
            ]
        },{
            imgUrl:require('../../assets/img/overseas/GNSS04.png'),
            type:'otherImg',
            children:[
                {
                    categoryCon:'Project No',
                    detailCon:'A8004',
                },{
                    categoryCon:'LCD',
                    detailCon:'8" HD 1280*800 / 1920*1200  500Nits',
                },
                { categoryCon:'Touch Panel',detailCon:'Capacitive'},
                { categoryCon:'Size',detailCon:'235*146*13mm'},
                { categoryCon:'Weight',detailCon:'630g'},
                { categoryCon:'Drop Test',detailCon:'1.2m'},
                { categoryCon:'Water proof',detailCon:'IP67'},
                { categoryCon:'Work Temp',detailCon:'-20℃ ~60℃'},
                { categoryCon:'Storage Temp',detailCon:'-30℃ ~70℃'},
                { categoryCon:'CPU',detailCon:'SDM4350 2*Kyro 460 Gold (A76) 2.0GHz + 6*Kyro 460 Silver (A55) 1.8GH'},
                { categoryCon:'OS',detailCon:'Android 12.0'},
                { categoryCon:'RAM',detailCon:'6/8GB'},
                { categoryCon:'Flash',detailCon:'128/256GB'},
                { categoryCon:'Rear Camera',detailCon:'13M'},
                { categoryCon:'Front Camera',detailCon:'5M'},
                { categoryCon:'Flast Light',detailCon:'Y'},
                { categoryCon:'WIFI',detailCon:'802.11 a/b/g/n,  2.4GHz/5GHz, WiFi6-Ready'},
                { categoryCon:'Network',detailCon:`
GSM:850/900/1800/1900 EVDO：BC0<br>
WCDMA: B1/B2/B5/B8 TD-SCDMA: B34/B39<br>
TDD-LTE:  Band38/Band39/Band40/Band41 FDD-LTE:
Band1/Band2/Band3/band4/band5/Band7/<br>band8/band17/band20/band2 8
5G: N41/N78/79`},
                { categoryCon:'SIM Card',detailCon:'Dual sim &  Dual standby'},
                { categoryCon:'T Card',detailCon:'Y'},
                { categoryCon:'Bluetooth',detailCon:'BT5.1'},
                { categoryCon:'USB',detailCon:`Type C`},
                { categoryCon:'Battery',detailCon:'8000mAh'},
                { categoryCon:'Fast Charge',detailCon:'QC3.0'},
                { categoryCon:'NFC',detailCon:'Y'},
                { categoryCon:'Fingerprint',detailCon:'N/A'},
                { categoryCon:'G Sensor',detailCon:'Y'},
                { categoryCon:'Gyroscope',detailCon:'Y'},
                { categoryCon:'Light Sensor',detailCon:'Y'},
                { categoryCon:'E Compass',detailCon:'Y'},
                { categoryCon:'GNSS',detailCon:'GPS/Beidou/GLONASS/GALILEO'},
                { categoryCon:'HIgh precious GPS',detailCon:' Ublox F9P is optional'},                
                { categoryCon:'GPS Antenna',detailCon:'PIFA'},
                { categoryCon:'External GPS Antenna',detailCon:'N'},
                { categoryCon:'Extended Interface',detailCon:`USB, UART, I2C, GPIO`},
                { categoryCon:'Keypad',detailCon:'Power，Volume up/down, F1, F2'},
            ]
        },{
            imgUrl:require('../../assets/img/overseas/GNSS05.png'),
            type:'',
            children:[
                {
                    categoryCon:'Project No',
                    detailCon:'A8005',
                },{
                    categoryCon:'LCD',
                    detailCon:'8" 1280*800 500nits',
                },
                { categoryCon:'Touch Panel',detailCon:'Capacitive'},
                { categoryCon:'Touch pen',detailCon:'Y'},
                { categoryCon:'Size',detailCon:'209mm*130mm*13.9mm'},
                { categoryCon:'Weight',detailCon:'525g'},
                { categoryCon:'Drop Test',detailCon:'1.2m'},
                { categoryCon:'Water proof',detailCon:'IP67'},
                { categoryCon:'Work Temp',detailCon:'-20℃ ~60℃'},
                { categoryCon:'Storage Temp',detailCon:'-30℃ ~70℃'},
                { categoryCon:'CPU',detailCon:'Qualcomm SDM632(4*A73+4*A53)  8*1.8GHZ'},
                { categoryCon:'OS',detailCon:'Android 10GMS'},
                { categoryCon:'RAM',detailCon:'4GB'},
                { categoryCon:'Flash',detailCon:'64GB'},
                { categoryCon:'Rear Camera',detailCon:'13M'},
                { categoryCon:'Front Camera',detailCon:'8M'},
                { categoryCon:'WIFI',detailCon:'802.11 a/b/g/n/ac,  2.4GHz/5GHz'},
                { categoryCon:'Network',detailCon:`GSM:850/900/1800/1900 <br>
                    WCDMA: B1/B2/B5/B8<br>
TDD-LTE:  Band38/Band39/Band40/Band41<br>
FDD-LTE:Band1/Band2/Band3/band4/band5/Band7/band8/band1 7/band20/band28`},
                { categoryCon:'SIM Card',detailCon:'Nano sim'},
                { categoryCon:'T Card',detailCon:'Y'},
                { categoryCon:'Bluetooth',detailCon:'BT4.2'},
                { categoryCon:'USB',detailCon:`Type C *1<br>
USB3.0 *2 Type A`},
                { categoryCon:'Battery',detailCon:`Main Battery：7000mAH
Standby Battery 400mAH （option)`},
                { categoryCon:'Fast Charge',detailCon:'Y'},
                { categoryCon:'NFC',detailCon:'Y'},
                { categoryCon:'RGB',detailCon:'Y'},
                { categoryCon:'Fingerprint',detailCon:'N/A'},
                { categoryCon:'G Sensor',detailCon:'Y'},
                { categoryCon:'Gyroscope',detailCon:'Y'},
                { categoryCon:'Light Sensor',detailCon:'Y'},
                { categoryCon:'E Compass',detailCon:'Y'},
                { categoryCon:'HDMI',detailCon:'Y'},
                { categoryCon:'Vibrator',detailCon:'Y'},
                { categoryCon:'GNSS',detailCon:'UBlox M8N'},
                { categoryCon:'GPS ANT',detailCon:'Patch'},
                { categoryCon:'External GPS Antenna',detailCon:`12PIN Back Pogopin，UART/USB/CAN/DCIN/GPIO
10PIN Bottom Pogopin，USB2.0/DCIN/GPIO`},
                { categoryCon:'Entity Key',detailCon:`Power，Volume up/down, F1/2/3/4`},
                { categoryCon:'Virtual Key',detailCon:`Menu/Back/Home`},
                { categoryCon:'SPK',detailCon:'AAC, Dual 1215 Speak'},
                { categoryCon:'MIC',detailCon:'Y'},
            ]
        }
    ],

    UAVLists:[
        {
            imgUrl:require('../../assets/img/overseas/uav-1.png'),
            children:[
                {
                    leftCon:'Take off weight',
                    rightCon:'246g',
                },{
                    leftCon:'Size',
                    rightCon:`Folded (without paddle) : length 138 mm, width 81 mm, height 58 mm<br>
                                Spread (including blade) : length 245 mm, width 289 mm, height 56 mm`,
                },{
                    leftCon:'Maximum range',
                    rightCon:'15.7km'
                },{
                    leftCon:'Maximum ascent speed',
                    rightCon:'5m/s', 
                },{
                    leftCon:'Maximum descent speed',
                    rightCon:'3.5m/s',
                },{
                    leftCon:'Maximum horizontal flight speed',
                    rightCon:'16m/s',
                },{
                    leftCon:'Maximum take-off altitude',
                    rightCon:'4000m',
                },{
                    leftCon:'Maximum flight time',
                    rightCon:'31minutes',
                },{
                    leftCon:'Maximum wind speed',
                    rightCon:'10.7m/s',
                },{
                    leftCon:'Maximum tilt Angle',
                    rightCon:'40°',
                },{
                    leftCon:'Operating ambient temperature',
                    rightCon:'0℃-40℃',
                },{
                    leftCon:'Satellite navigation system',
                    rightCon:'Beidou',
                }
            ],
        },{
            imgUrl:require('../../assets/img/overseas/uav-2.png'),
            children:[
                {
                    leftCon:'Take off weight',
                    rightCon:'958g',
                },{
                    leftCon:'Size',
                    rightCon:`Folded (without paddle) : length 231.1 mm, width 98 mm, height 95.4 mm<br>
                                Spread (including blade) : length 347.5 mm, width 290.8 mm, height 107.7 mm`,
                },{
                    leftCon:'Maximum range',
                    rightCon:'728km'
                },{
                    leftCon:'Maximum ascent speed',
                    rightCon:'8m/s', 
                },{
                    leftCon:'Maximum descent speed',
                    rightCon:'6m/s',
                },{
                    leftCon:'Maximum horizontal flight speed',
                    rightCon:'21m/s',
                },{
                    leftCon:'Maximum take-off altitude',
                    rightCon:'6000m',
                },{
                    leftCon:'Maximum flight time',
                    rightCon:'43minutes',
                },{
                    leftCon:'Maximum wind speed',
                    rightCon:'12m/s',
                },{
                    leftCon:'Maximum tilt Angle',
                    rightCon:'35°',
                },{
                    leftCon:'Operating ambient temperature',
                    rightCon:'-10℃-40℃',
                },{
                    leftCon:'Satellite navigation system',
                    rightCon:'Beidou',
                }
            ], 
        },{
            imgUrl:require('../../assets/img/overseas/uav-3.png'),
            children:[
                {
                    leftCon:'Take off weight',
                    rightCon:'4310g',
                },{
                    leftCon:'RTK position accuracy',
                    rightCon:`1cm+1PPM (horizontal)<br>
1.5cm+1PPM (vertical)`,
                },{
                    leftCon:'Maximum rotative speed',
                    rightCon:`Pitch axis: 200°/ s<br>
Horizontal roller: 200°/ s<br>
Yaw axis: 150°/ s`,
                },{
                    leftCon:'Maximum ascent speed',
                    rightCon:'8m/s', 
                },{
                    leftCon:'Maximum descent speed',
                    rightCon:'8m/s',
                },{
                    leftCon:'Maximum horizontal flight speed',
                    rightCon:'94km/h',
                },{
                    leftCon:'Maximum take-off altitude',
                    rightCon:'7000m',
                },{
                    leftCon:'Maximum flight time',
                    rightCon:'28minutes',
                },{
                    leftCon:'Maximum wind speed',
                    rightCon:'12m/s',
                },{
                    leftCon:'Maximum tilt Angle',
                    rightCon:'35°',
                },{
                    leftCon:'Operating ambient temperature',
                    rightCon:'-20℃-40℃',
                },{
                    leftCon:'Satellite navigation system',
                    rightCon:'Beidou',
                }
            ],
        }
    ]
}